module.exports = __webpack_public_path__ + "img/swiper_3.e2cfea2e.png";